<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/mobileHome')" class="breadcrumbs-txt">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1">关于One A Day®</div>
    </div>
    <div class="main-content">
      <img class="banner" src="@/assets/mobile/about/banner.png" alt="" />
      <div class="content-textBox">
        <div class="content-textBox-txt">从营养补充到食用感受，One A Day致力于为消费者提供全面优 质的产品体验帮助每一位消费者达到健康生活状态</div>
        <div class="content-textBox-title">提供定制化解决方案</div>
        <div class="content-textBox-txt" style="margin-top: 0.67rem; margin-bottom: 0.75rem">不同性别，不同年龄，不同人生阶段每个人对于营养补充的需求 都大不相同One A Day是一个多元营养补充剂品牌， 我们为消费者提供多样完整的产品组合</div>
        <div @click="clicklistItem('品牌理念')" class="content-listItemBox flex ai jcs">
          <div class="content-listItemBox-title">品牌理念</div>
          <img class="iconAdd" :src="require(`@/assets/mobile/about/icon${showlistItem1 ? 'Reduction' : 'Add'}.png`)" alt="" />
        </div>
        <transition name="fade">
          <div v-if="showlistItem1" class="content-expansionItemBox">
            <div class="content-expansionItemBox-txt">80多年来，我们一直引领维生素创新——我们不会停下脚步，我们相信健康是获得更好自我的关键。我们将一直坚持使用专业的原料成分并且持续优化产品配方，以给到消费者科学先进的营养补充。</div>
          </div>
        </transition>
        <div @click="clicklistItem('质量保证')" class="content-listItemBox flex ai jcs">
          <div class="content-listItemBox-title">质量保证</div>
          <img class="iconAdd" :src="require(`@/assets/mobile/about/icon${showlistItem2 ? 'Reduction' : 'Add'}.png`)" alt="" />
        </div>
        <transition name="fade">
          <div v-if="showlistItem2" class="content-expansionItemBox">
            <div class="content-expansionItemBox-txt">一直以来，我们在产品质量方面都以最高标准来要求自己。我们的产品都是经过 100 多项严格的质量检查，以确保产品安全与功效。我们致力于以我们能提供的最佳质量为消费者服务。</div>
          </div>
        </transition>
        <div @click="clicklistItem('科学配方')" class="content-listItemBox flex ai jcs">
          <div class="content-listItemBox-title">科学配方</div>
          <img class="iconAdd" :src="require(`@/assets/mobile/about/icon${showlistItem3 ? 'Reduction' : 'Add'}.png`)" alt="" />
        </div>
        <transition name="fade">
          <div v-if="showlistItem3" class="content-expansionItemBox">
            <div class="content-expansionItemBox-txt">每一款产品的诞生都离不开我们经验丰富的研发人员和专业科学家团队的共同努力。 我们致力于解决每一位消费者在健康方面的首要需求，研究并开发独家成分配方以满足消费者的差异化需求。</div>
          </div>
        </transition>
      </div>
      <MobileFooter />
    </div>
  </div>
</template>

<script setup>
import MobileFooter from "@/components/mobileFooter.vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
import { ref } from "vue";
const showlistItem1 = ref(false);
const showlistItem2 = ref(false);
const showlistItem3 = ref(false);
const clicklistItem = (type) => {
  if (type === "品牌理念") {
    showlistItem1.value = !showlistItem1.value;
  } else if (type === "质量保证") {
    showlistItem2.value = !showlistItem2.value;
  } else if (type === "科学配方") {
    showlistItem3.value = !showlistItem3.value;
  }
};
</script>

<style src="./mobileAbout.css" scoped></style>
